/* Yool Primitives · botones, inputs, fields, badges, avatar, tabs.
   Consumen clases CSS de yool-admin.css. No dependen de shadcn/lucide. */

import React from 'react';

export function YBtn({ variant = 'primary', size = 'md', icon, children, className = '', ...rest }) {
  const cls = [
    'y-btn',
    `y-btn-${variant}`,
    size === 'sm' ? 'y-btn-sm' : '',
    className,
  ].filter(Boolean).join(' ');
  return (
    <button className={cls} {...rest}>
      {icon}
      {children}
    </button>
  );
}

export function YIconBtn({ variant = 'quiet', size = 'md', children, title, className = '', ...rest }) {
  const cls = [
    'y-btn',
    `y-btn-${variant}`,
    'y-btn-icon',
    size === 'sm' ? 'y-btn-sm' : '',
    className,
  ].filter(Boolean).join(' ');
  return <button className={cls} title={title} {...rest}>{children}</button>;
}

export function YField({ label, required, hint, children, span }) {
  return (
    <div className="y-field" style={span ? { gridColumn: `span ${span}` } : undefined}>
      <label className="y-field-label">
        {label}
        {required && <span className="y-req">*</span>}
      </label>
      {children}
      {hint && <span className="y-field-hint">{hint}</span>}
    </div>
  );
}

export function YInput({ error, ...rest }) {
  return <input className={`y-input${error ? ' error' : ''}`} {...rest} />;
}

export function YSelect({ children, ...rest }) {
  return <select className="y-select" {...rest}>{children}</select>;
}

export function YBadge({ tone = 'outline', dot, children, style }) {
  return (
    <span className={`y-badge y-badge-${tone}`} style={style}>
      {dot && <span className="y-dot" />}
      {children}
    </span>
  );
}

export function YAvatar({ initials, color, logoUrl, size = 32, square = true }) {
  const dim = { width: size, height: size };
  const radius = square ? Math.max(8, size * 0.28) : 9999;
  if (logoUrl) {
    return (
      <div style={{
        ...dim, borderRadius: radius, background: '#fff',
        border: '1px solid var(--yool-border)',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        overflow: 'hidden', flexShrink: 0,
      }}>
        <img src={logoUrl} alt="" style={{ maxWidth: '78%', maxHeight: '78%', objectFit: 'contain' }}
          onError={(e) => { e.currentTarget.style.display = 'none'; }} />
      </div>
    );
  }
  return (
    <div style={{
      ...dim, borderRadius: radius,
      background: color || 'var(--yool-navy)',
      color: '#fff',
      fontSize: size * 0.36,
      fontWeight: 700,
      letterSpacing: '-.01em',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      flexShrink: 0,
    }}>
      {initials}
    </div>
  );
}

export function YTabs({ tabs, value, onChange }) {
  return (
    <div className="y-tabs">
      {tabs.map(t => (
        <button
          key={t.id}
          className={`y-tab${value === t.id ? ' active' : ''}`}
          onClick={() => onChange(t.id)}
        >
          {t.label}
          {typeof t.count === 'number' && <span className="y-badge-mini">{t.count}</span>}
        </button>
      ))}
    </div>
  );
}

export function colorFor(str) {
  const palette = ['#0E2640', '#007D6E', '#2563EB', '#5B2BE5', '#0EA5E9', '#147D89', '#0784A0'];
  let h = 0;
  for (let i = 0; i < (str || '').length; i++) h = ((h << 5) - h + str.charCodeAt(i)) | 0;
  return palette[Math.abs(h) % palette.length];
}

export function initialsOf(name = '') {
  return name.split(/\s+/).filter(Boolean).slice(0, 2).map(w => w[0]).join('').toUpperCase() || '·';
}
